import React, {Component} from 'react';
import SingleMessage from '../View';
import Pagination from "react-js-pagination";

class Paginate extends Component {
    constructor(props) {
        super(props);

        this.state = {
            activePage : 1,
            itemsPerPage : 25
        }
    }

    handlePageChange = (pageNumber) => {
        this.setState({
            activePage: pageNumber
        });

        this.props.resetActiveItems();
    }

    componentDidUpdate(prevProps) {
        if ( this.props.data.length !== prevProps.data.length ) {
            this.setState({
                ...this.state,
                activePage : 1
            })
        }
    }

    _mapMessages = (message, key) => {

        if(!message)
            return null;

        let messageClass = "message";
        if(message.has_been_read === "0") {
            messageClass = messageClass + ' message--unread';
        }

        if ( message.has_been_read_clientside ) {
            messageClass = 'message';
        }

        let activeClass = message.is_active ? 'single__message--visible' : '';
        return (
            <SingleMessage
                isFromOverview={this.props.isFromOverview}
                selectedMessages={this.props.selectedMessages}
                setActiveCheckbox={this.props.setActiveCheckbox}
                key={key}
                setSearchTerm={this.props.setSearchTerm}
                showDetails={this.props.showDetails}
                messageClass={messageClass}
                message={message}
                activeClass={activeClass}
            />
        )
    }

    _getActiveData = data => {
        let newData = [];

        data.forEach((item, i) => {
            if ( this.props.visibleMessages.includes(item.message_id)) {
                item.is_active = true;
            } else {
                item.is_active = false;
            }

            newData.push(item);
        });

        return newData;
    }

    _renderActiveItems() {
        const data = this._getActiveData(this.props.data);

        const displayFrom = (this.state.itemsPerPage * this.state.activePage) - this.state.itemsPerPage;
        const displayTo = (displayFrom + this.state.itemsPerPage) - 1;

        let dataToDisplay = [];
        let count = 0;
        data.forEach((item, i) => {
            if ( count >= displayFrom && count <= displayTo) {
                dataToDisplay.push(item);
            }
            count++;
        });

        return dataToDisplay;

    }

    render() {
        return (
            <React.Fragment>

                    {this._renderActiveItems().map(this._mapMessages)}


                <Pagination
                  activePage={this.state.activePage}
                  itemsCountPerPage={this.state.itemsPerPage}
                  totalItemsCount={this.props.data.length}
                  pageRangeDisplayed={5}
                  onChange={this.handlePageChange}
                  />
             </React.Fragment>
        )
    }

}


export default Paginate



// WEBPACK FOOTER //
// ./src/components/Messages/Pagination/index.js